// Data + logik templat "Hosted Flow Notifications" (email ringkasan batch Hosted Flow).
// Diasingkan daripada useTemplatTransaksi.js (folder "Payment emails") kerana ia menu
// BERASINGAN dalam tab Email Blast — tetapi SIMPAN ke doc yang SAMA
// (email_settings/transactional.templates.hosted_batch_done) dan reuse editor + Resend
// + email_logs sedia ada. TIADA composer / sistem templat kedua.
//
// ⚠️ KEMBAR: templat hosted_batch_done + tanda ganti ada salinannya di server
//    `functions/emailTransaksi.js` (TEMPLAT_LALAI.hosted_batch_done). Ubah → ubah DUA fail.
// ⚠️ LALAI = MATI (keputusan owner: proofread dahulu sebelum pelanggan terima).
import { useState, useEffect, useCallback } from 'react';
import { db } from '../firebase';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { masalahTemplat } from './useTemplatTransaksi';

const BUKA_APP = 'https://app.sesaat.ai';

// Satu templat sahaja buat masa ini. Bentuk SAMA dgn TEMPLAT_LALAI payment (editor generik).
export const TEMPLAT_HOSTED = [
    {
        id: 'hosted_batch_done',
        nama: 'Hosted Flow — batch video siap',
        bila: 'Dihantar automatik oleh server apabila SATU batch Hosted Flow selesai diproses (semua video terminal). Bukan email pemasaran.',
        subject: 'SESAAT — Video Hosted Flow Anda Dah Siap!',
        bodyText: `Hai {{nama}},\n\nBatch Hosted Flow anda sudah selesai diproses.\n\nJumlah video: **{{total}}**\n✅ Berjaya: **{{berjaya}}**\n⚠️ Perlu semakan: **{{perluSemakan}}**\n❌ Gagal: **{{gagal}}**\n\nVideo yang berjaya sudah disimpan pada Product Card anda dalam SESAAT.\n\n[Buka Workspace SESAAT](${BUKA_APP})\n\nJika ada video yang memerlukan semakan, status berkaitan akan dipaparkan dalam Workspace.\n\nTerima kasih,\nSESAAT.AI`,
        tandaGanti: ['nama', 'total', 'berjaya', 'perluSemakan', 'gagal'],
    },
];

function binaItems(tersimpan) {
    return TEMPLAT_HOSTED.map((t) => {
        const s = (tersimpan && tersimpan[t.id]) || {};
        return {
            ...t,
            enabled: typeof s.enabled === 'boolean' ? s.enabled : false,
            subject: typeof s.subject === 'string' && s.subject.trim() ? s.subject : t.subject,
            bodyText: typeof s.bodyText === 'string' && s.bodyText.trim() ? s.bodyText : t.bodyText,
        };
    });
}

// Hook — sama corak useTemplatTransaksi tetapi untuk templat hosted sahaja. Simpan = merge dalam
// → templat payment dalam doc yang sama TIDAK disentuh (medan templates.{id} berasingan).
export function useTemplatHosted() {
    const [items, setItems] = useState(() => binaItems(null));
    const [loading, setLoading] = useState(true);
    const [ralat, setRalat] = useState('');

    const muat = useCallback(async () => {
        setLoading(true); setRalat('');
        try {
            const snap = await getDoc(doc(db, 'email_settings', 'transactional'));
            setItems(binaItems(snap.exists() ? (snap.data().templates || {}) : {}));
        } catch (e) {
            console.error('[HostedEmail] load failed:', e);
            setRalat('Failed to load saved template: ' + e.message + ' — showing default (OFF).');
            setItems(binaItems(null));
        } finally { setLoading(false); }
    }, []);
    useEffect(() => { muat(); }, [muat]);

    const simpanSatu = useCallback(async (t) => {
        const m = masalahTemplat(t);
        if (m.length) throw new Error(m.join(' '));
        await setDoc(doc(db, 'email_settings', 'transactional'), {
            templates: { [t.id]: { enabled: !!t.enabled, subject: t.subject, bodyText: t.bodyText } },
            updatedAt: serverTimestamp(),
        }, { merge: true });
        setItems((prev) => prev.map((x) => (x.id === t.id ? { ...x, enabled: !!t.enabled, subject: t.subject, bodyText: t.bodyText } : x)));
    }, []);

    return { items, loading, ralat, muat, simpanSatu };
}
